import {
    sso2AppInvoked,
    sso2AppSuccess,
    sso2AppFailed,
    SSO_LOGIN_2_LIGHTNING,
    SSO_LOGIN_2_APP
} from '../sso';
import { put, call, takeLatest } from 'redux-saga/effects';
import { sso2App as sso2AppClient, getAslSSOUrl } from '~/client';
import { combineUrl, getProfileToken, getToken } from '~/common';
import { store } from '~/index.js';
import { authTimeout } from '../application';

function* sso2Lightning(action) {
    try {
        yield put(sso2AppInvoked());
        const params = {
            AccessToken: getToken(),
            profileToken: getProfileToken() || '',
        };
        if (!params.AccessToken) {
            yield put(authTimeout());
        } else {
            const bkgRef = action.payload.BkgRef;
            const calendarKey = action.payload.CalendarKey;
            const payload = yield call(getAslSSOUrl, { profileToken: params.profileToken, bkgRef, calendarKey });
            if (payload.Url) {
                yield put(sso2AppSuccess(payload));
            } else {
                yield put(sso2AppFailed(payload.Msg));
            }
        }
    } catch (ex) {
        yield put(sso2AppFailed(ex.message));
    }
}

function* sso2App(action) {
    try {
        const { SystemId, AppId } = action.payload;
        let params = {
            profileToken: getProfileToken() || '',
            SystemId,
            AppId,
            AccessToken: getToken()
        }
        if (!params.AccessToken) {
            yield put(authTimeout());
        } else {
            yield put(sso2AppInvoked(action.payload));
            const payload = yield call(sso2AppClient, params);
            yield put(sso2AppSuccess(payload));
        }
    } catch (ex) {
        yield put(sso2AppFailed(ex.message));
    }
}

export default function* () {
    yield takeLatest(SSO_LOGIN_2_LIGHTNING, sso2Lightning);
    yield takeLatest(SSO_LOGIN_2_APP, sso2App);
}
